import React from "react"
import { CheckCircle, RadioButtonUnchecked, AutoMode, TrendingUp, TrendingDown, Shuffle } from "@mui/icons-material"
import type { AuditTypeOption, AutomaticTypeOption } from "./types"

export const AUDIT_STEPS = ["Choose Audit Type", "Configure Selection", "Review & Create"]

export const AUDIT_TYPES: AuditTypeOption[] = [
  {
    value: "all",
    label: "All Products",
    description: "Audit all products in the selected location",
    icon: React.createElement(CheckCircle)
  },
  {
    value: "automatic",
    label: "Automatic Selection",
    description: "Automatically select products based on criteria",
    icon: React.createElement(AutoMode)
  },
  {
    value: "specific",
    label: "Specific Products",
    description: "Manually select specific products to audit",
    icon: React.createElement(RadioButtonUnchecked)
  }
]

export const AUTOMATIC_TYPES: AutomaticTypeOption[] = [
  {
    value: "high",
    label: "High Selling",
    description: "Products with highest sales in last 90 days",
    icon: React.createElement(TrendingUp, { color: "success" })
  },
  {
    value: "low",
    label: "Low Selling",
    description: "Products with lowest sales in last 90 days",
    icon: React.createElement(TrendingDown, { color: "warning" })
  },
  {
    value: "random",
    label: "Random Selection",
    description: "Randomly selected products from inventory",
    icon: React.createElement(Shuffle, { color: "info" })
  }
]

export const DEFAULT_FORM_DATA = {
  location: "",
  type: "all" as const,
  percentage: 10
}

export const VALIDATION_RULES = {
  MIN_PERCENTAGE: 1,
  MAX_PERCENTAGE: 10
} as const

export const ANIMATION_CONFIG = {
  SLIDE_TIMEOUT: 300,
  TRANSITION_DELAY: 50,
  EASING: {
    enter: "cubic-bezier(0.4, 0, 0.2, 1)",
    exit: "cubic-bezier(0.4, 0, 0.6, 1)"
  }
} as const
